import * as React from "react";

import primaryColour from "../../constants";

function SvgIgnitionon(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.90797 8.01001C9.42295 8.01001 10.7414 8.85623 11.417 10.1L19.498 10.1L21.398 11.81L18.738 13.9L17.598 12.76L16.458 13.9L15.318 12.76L14.178 13.9L11.417 13.9C10.7414 15.1438 9.42295 15.99 7.90797 15.99C5.70436 15.99 3.91797 14.2036 3.91797 12C3.91797 9.79641 5.70436 8.01001 7.90797 8.01001ZM6.57799 10.86C5.94837 10.86 5.43798 11.3704 5.43799 12C5.43798 12.6296 5.94838 13.14 6.57799 13.14C7.20758 13.14 7.71798 12.6296 7.71797 12C7.71798 11.3704 7.20758 10.86 6.57799 10.86Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgIgnitionon;
